export default "__VITE_ASSET__Za0TJJ8A__"